import axios, { AxiosError, AxiosResponse } from 'axios'

import { API_STAGES, API_URLS } from '../api'
import { RebillyCreateTransactionParams, RebillyCreateTransactionResult } from '../models'
import { query } from './query'

export const createTransactionGpc = async (params: RebillyCreateTransactionParams): Promise<RebillyCreateTransactionResult> => {
  try {
    const { sandbox } = params
    const result = await axios.post<{ query: string; variables: string }, AxiosResponse<RebillyCreateTransactionResult>>(
      sandbox ? API_URLS.local : API_URLS.prod,
      {
        query,
        variables: JSON.stringify(params),
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Stage': sandbox ? API_STAGES.local : API_STAGES.prod,
        },
      },
    )
    if (result.data === undefined) {
      throw Error(JSON.stringify(result))
    }
    return result.data
  } catch (ex) {
    const error = ex as AxiosError
    if (error.response) {
      console.log(`Error: ${JSON.stringify(error.response.data)}`)
    }
    throw ex
  }
}
